"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const PrimaryButton_1 = __importDefault(require("../../../components/button/PrimaryButton"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const helpler_1 = require("../../../utils/helpler");
const NotificationChangePass = (props) => {
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                    fontSize: 14,
                }, title: "パスワードを忘れた方", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, onLeftPress: () => {
                    (0, rootNavigation_1.goBack)();
                } }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(15),
                                lineHeight: (0, scale_1.moderateScale)(23),
                                color: "#292A33",
                                fontWeight: "300",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u5B8C\u4E86")),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            fontWeight: "300",
                            marginTop: 12,
                        } }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u518D\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"),
                    react_1.default.createElement(PrimaryButton_1.default, { onPress: () => {
                            props.navigation.navigate("LOGIN");
                        }, title: "\u30DB\u30FC\u30E0\u753B\u9762\u3078", textStyle: { color: "#1960B0", fontWeight: "300" }, style: styles_1.default.buttonSend }))))));
};
exports.default = NotificationChangePass;
